<template>
  <div class="body">
    <h1>Referenzwerttabelle</h1>
    <p class="fliesstext">
      In dieser Tabelle finden Sie die auf Ihre Filtersuche angepassten Daten.
      Im zweiten Teil der tabellarischen Darstellung sind die Fußnoten (FN)
      angehangen, die ebenfalls zu den jeweiligen Nährstoffen genannt werden.
    </p>
    <template v-if="showSearchNowButton">
    <v-row>
      <!-- neue Expansion Panels mit funktionierendem Databinding -->
      <v-expansion-panels class="leftList">
        <v-expansion-panel class="targetGroupsExpansionPanel">
          <div>
          <v-expansion-panel-header class="heading">Zielgruppen</v-expansion-panel-header>
          </div>
          <div class="border">
          <v-expansion-panel-content>
            <v-row>

              <v-expansion-panel-content>
                  <div class="firstEbene firstLabel gender-box">
                    <label class="b-contain weiblich">
                      <input type="checkbox" id="gender_w"  v-model="karo_data.sexes[1].selected"/>
                      <div class="b-input"></div>Weiblich</label>
                      <label class="b-contain">
                      <input type="checkbox" id="gender_m" v-model="karo_data.sexes[0].selected"/>
                      <div class="b-input"></div>Männlich</label>
                  </div>
                  </v-expansion-panel-content>
              
              <v-expansion-panels multiple accordion class="InnerPanels">
                <v-expansion-panel>
                  <div class="b-contain">
                  <input type="checkbox" class="check" v-model="babiesSelected" :indeterminate.prop="babiesSelectedIndeterminate"/>
                  <div class="b-input b-position">
                  </div>
                  </div>
                  <v-expansion-panel-header>
                    <label class="b-contain">
                      <div class="b-input"></div>Säuglinge</label>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" class="check check-two" v-model="selectedGroups" :value="0"/>
                        0 bis unter 4 Monate
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="1"/>
                        4 bis unter 12 Monate
                        <div class="b-input"></div>
                      </label>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <div class="b-contain">
                  <input type="checkbox" class="check" v-model="childrenSelected" :indeterminate.prop="childrenSelectedIndeterminate"/>
                  <div class="b-input b-position">
                  </div>
                  </div>
                  <v-expansion-panel-header><label class="b-contain">
                    Kinder & Jugendliche
                    <div class="b-input"></div>
                  </label></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="2"/>
                        1 bis unter 4 Jahre
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="3"/>
                        4 bis unter 7 Jahre
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="4"/>
                        7 bis unter 10 Jahre
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="5"/>
                        10 bis unter 13 Jahre
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="6"/>
                        13 bis unter 15 Jahre
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="7"/>
                        15 bis unter 19 Jahre
                        <div class="b-input"></div>
                      </label>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <div class="b-contain">
                  <input type="checkbox" class="check" v-model="adultSelected" :indeterminate.prop="adultSelectedIndeterminate"/>
                  <div class="b-input b-position">
                  </div>
                  </div>
                  <v-expansion-panel-header><label class="b-contain">
                    Erwachsene
                    <div class="b-input"></div>
                  </label></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="8"/>
                        19 bis unter 25 Jahre
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="9"/>
                        25 bis unter 51 Jahre
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="10"/>
                        51 bis unter 65 Jahre
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="11"/>
                        65 Jahre und älter
                        <div class="b-input"></div>
                      </label>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <div class="b-contain">
                  <input type="checkbox" class="check" v-model="pregnantsSelected" :indeterminate.prop="pregnantsSelectedIndeterminate"/>
                  <div class="b-input b-position">
                  </div>
                  </div>
                  <v-expansion-panel-header><label class="b-contain">
                    Schwangere
                    <div class="b-input"></div>
                  </label></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="12"/>
                        1. Trimester
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="13"/>
                        2. Trimester
                        <div class="b-input"></div>
                      </label>
                    </div>
                    <div class="firstEbene">
                      <label class="b-contain">
                        <input type="checkbox" v-model="selectedGroups" :value="14"/>
                        3. Trimester
                        <div class="b-input"></div>
                      </label>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
            <div class="firstEbene firstLabel">
              <label class="b-contain">
                <input type="checkbox" v-model="selectedGroups" :value="15"/>
                Stillende
                <div class="b-input"></div>
              </label>
            </div>
          </v-expansion-panel-content>
          </div>
        </v-expansion-panel>
        <v-alert
            color="green"
            type="info"
            text
            v-if="showWarningNoGroupsSelected"
        >Bitte wählen Sie eine oder mehrere Zielgruppen aus.</v-alert>
        <v-alert
            color="green"
            type="info"
            text
            v-if="showWarningNoSexesSelected"
        >Bitte wählen Sie eins oder mehrere Geschlechter aus.</v-alert>
      </v-expansion-panels>
      <v-expansion-panels multiple class="rightList">
        <v-expansion-panel class="targetGroupsExpansionPanel">

          <v-expansion-panel-header class="heading">Nährstoffe</v-expansion-panel-header>
          <div class="border">
          <v-expansion-panel-content class="InnerPanels firstLvl">
            <label class="b-contain">
              <input type="checkbox" v-model="selectedNutrients" :value="0"/>
              Energie
              <div class="b-input first"></div>
            </label>
            <v-expansion-panel>
              <div class="b-contain">
                  <input type="checkbox" class="check" v-model="nutrientGroup1Selected"
                         :indeterminate.prop="nutrientGroup1SelectedIndeterminate"/>
                  <div class="b-input b-position">
                  </div>
                  </div>
              <v-expansion-panel-header>
                <label class="b-contain">
                  
                  Energieliefernde Nährstoffe
                  <div class="b-input"></div>
                </label>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-expansion-panel class="secondEbene secondLvl">
                  <div class="b-contain">
                  <input type="checkbox" class="check2" v-model="nutrientGroup2Selected"
                           :indeterminate.prop="nutrientGroup2SelectedIndeterminate"/>
                  <div class="b-input b-position2">
                  </div>
                  </div>

                  <v-expansion-panel-header><label class="b-contain">
                    Fett
                    <div class="b-input"></div>
                  </label></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                        v-for="nutrient in nutrientsForGroup(2)"
                        :key="nutrient.name" class="thirdLvl"
                    >
                      <label class="b-contain">
                        <input
                            type="checkbox"
                            v-model="selectedNutrients"
                            :value="nutrient.nutrient_id"
                        />
                        {{ nutrient.name }}
                        <div class="b-input"></div>
                      </label>
                    </div>

                    <v-expansion-panel class="thirdLvl greenBackground">
                      
                      <label class="b-contain">
                        <input type="checkbox" v-model="nutrientGroup3Selected"
                                :indeterminate.prop="nutrientGroup3SelectedIndeterminate" class="thirdLayerInput">
                        
                        <div class="b-input" style="z-index: 99999;margin-left: 4.6rem;margin-top: 1rem;"></div>
                      </label>

                      <v-expansion-panel-header><label class="b-contain" style="padding-left:4.8rem">
                        Fettsäuren
                        <div class="b-input"></div>
                      </label></v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div
                            v-for="nutrient in nutrientsForGroup(3)"
                            :key="nutrient.name" class="thirdLvl"
                        >
                          <label class="b-contain thirdLayerCheckbox">
                            <input
                                type="checkbox"
                                v-model="selectedNutrients"
                                :value="nutrient.nutrient_id"
                                class="thirdLayerInput"
                            />
                            {{ nutrient.name }}
                            <div class="b-input"></div>
                          </label>
                        </div>
                        <v-expansion-panel class="thirdLvl greenBackground">
                          

                        <label class="b-contain">
                            <input type="checkbox" v-model="nutrientGroup11Selected"
                                   :indeterminate.prop="nutrientGroup11SelectedIndeterminate"
                                   class="thirdLayerInput" style="left:1rem"
                                  />
                          <div class="b-input" style="z-index: 99999;margin-left: 5.5rem;margin-top: 1rem;"></div>
                        </label>
                            
                          <v-expansion-panel-header><label class="b-contain thirdLayerCheckbox" style="padding-left:4.8rem">
                            Mehrfach <br> ungesättigte Fettsäuren
                            <div class="b-input"></div>
                          </label></v-expansion-panel-header>
                          <v-expansion-panel-content id="invisFirstChild">
                            <div
                                v-for="nutrient in nutrientsForGroup(11)"
                                :key="nutrient.name" class="thirdLvl fourthdLayerCheckbox"
                            >
                              <label class="b-contain" style="padding-left:4.8rem">
                                <input
                                    type="checkbox"
                                    v-model="selectedNutrients"
                                    :value="nutrient.nutrient_id"
                                />
                                {{ nutrient.name }}
                                <div class="b-input" style="left:3rem !important"></div>
                              </label>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <div
                    v-for="nutrient in nutrientsForGroup(1)"
                    :key="nutrient.name" class="secondLvl einruecken"
                >
                  <label class="b-contain">
                    <input
                        type="checkbox"
                        v-model="selectedNutrients"
                        :value="nutrient.nutrient_id"
                    />
                    {{ nutrient.name }}
                    <div class="b-input"></div>
                  </label>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <div class="b-contain">
                  <input type="checkbox" class="check" v-model="nutrientGroup4Selected"
                         :indeterminate.prop="nutrientGroup4SelectedIndeterminate"/>
                  <div class="b-input b-position">
                  </div>
                  </div>
              <v-expansion-panel-header>
                <label class="b-contain">
                  
                  Vitamine
                <div class="b-input"></div></label>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-expansion-panel class="secondLvl">
                  <v-expansion-panel class="secondLvl">
                  <div class="b-contain">
                  <input type="checkbox" class="check2" v-model="nutrientGroup5Selected"
                           :indeterminate.prop="nutrientGroup5SelectedIndeterminate"/>
                  <div class="b-input b-position2">
                  </div>
                  </div>
                  <v-expansion-panel-header><label class="b-contain">
                    Fettlösliche Vitamine
                  <div class="b-input"></div></label></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                        v-for="nutrient in nutrientsForGroup(5)"
                        :key="nutrient.name" class="thirdLvl accordfix"
                    >
                      <label class="b-contain">
                        <input
                            type="checkbox"
                            v-model="selectedNutrients"
                            :value="nutrient.nutrient_id"
                        />
                        {{ nutrient.name }}
                      <div class="b-input"></div></label>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                  <div class="b-contain">
                  <input type="checkbox" class="check2" v-model="nutrientGroup6Selected"
                           :indeterminate.prop="nutrientGroup6SelectedIndeterminate"/>
                  <div class="b-input b-position2">
                  </div>
                  </div>
                  <v-expansion-panel-header><label class="b-contain">
                    Wasserlösliche Vitamine
                  <div class="b-input secondLvl"></div></label></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                        v-for="nutrient in nutrientsForGroup(6)"
                        :key="nutrient.name" class="thirdLvl accordfix"
                    >
                      <label class="b-contain">
                        <input
                            type="checkbox"
                            v-model="selectedNutrients"
                            :value="nutrient.nutrient_id"
                        />
                        {{ nutrient.name }}
                      <div class="b-input"></div></label>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- <v-expansion-panel class="secondLvl">
                  <div class="b-contain">
                  <input type="checkbox" class="check2" v-model="nutrientGroup6Selected"
                           :indeterminate.prop="nutrientGroup6SelectedIndeterminate"/>
                  <div class="b-input b-position2">
                  </div>
                  </div>
                  <v-expansion-panel-header><label class="b-contain">
                    Fettlösliche Vitamine
                  <div class="b-input"></div></label></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                        v-for="nutrient in nutrientsForGroup(5)"
                        :key="nutrient.name" class="thirdLvl accordfix"
                    >
                      <label class="b-contain">
                        <input
                            type="checkbox"
                            v-model="selectedNutrients"
                            :value="nutrient.nutrient_id"
                        />
                        {{ nutrient.name }}
                      <div class="b-input"></div></label>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel> -->
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <div class="b-contain">
                  <input type="checkbox" class="check" v-model="nutrientGroup7Selected"
                         :indeterminate.prop="nutrientGroup7SelectedIndeterminate"/>
                  <div class="b-input b-position">
                  </div>
                  </div>
              <v-expansion-panel-header>
                <label class="b-contain">
                  
                  Mineralstoffe
                <div class="b-input"></div></label>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-expansion-panel class="secondLvl">
                  <div class="b-contain">
                  <input type="checkbox" class="check2" v-model="nutrientGroup8Selected"
                           :indeterminate.prop="nutrientGroup8SelectedIndeterminate"/>
                  <div class="b-input b-position2">
                  </div>
                  </div>
                  <v-expansion-panel-header><label class="b-contain">
                    Mengenelelemente
                  <div class="b-input"></div></label></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                        v-for="nutrient in nutrientsForGroup(8)"
                        :key="nutrient.name" class="thirdLvl accordfix"
                    >
                      <label class="b-contain">
                        <input
                            type="checkbox"
                            v-model="selectedNutrients"
                            :value="nutrient.nutrient_id"
                        />
                        {{ nutrient.name }}
                      <div class="b-input"></div></label>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="secondLvl">
                  <div class="b-contain">
                  <input type="checkbox" class="check2" v-model="nutrientGroup9Selected"
                           :indeterminate.prop="nutrientGroup9SelectedIndeterminate"/>
                  <div class="b-input b-position2">
                  </div>
                  </div>
                  <v-expansion-panel-header><label class="b-contain">
                    Spurenelemente
                  <div class="b-input"></div></label></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                        v-for="nutrient in nutrientsForGroup(9)"
                        :key="nutrient.name" class="thirdLvl accordfix"
                    >
                      <label class="b-contain">
                        <input
                            type="checkbox"
                            v-model="selectedNutrients"
                            :value="nutrient.nutrient_id"
                        />
                        {{ nutrient.name === "Zink" && nutrient.addition.length > 0 ? nutrient.name + " " + nutrient.addition : nutrient.name }}
                        <div class="b-input"></div>
                      <div class="b-input"></div></label>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <div
                v-for="nutrient in nutrientsForGroup(0)"
                :key="nutrient.name" class="firstLabel"
            >
              <label class="b-contain">
                <input
                    type="checkbox"
                    v-model="selectedNutrients"
                    :value="nutrient.nutrient_id"
                />
                {{ nutrient.name }}
              <div class="b-input"></div></label>
            </div>
          </v-expansion-panel-content>
          </div>
        </v-expansion-panel>
        <v-alert
            color="green"
            type="info"
            text
            v-if="showWarningNoNutrientsSelected"
        >Bitte wählen Sie einen oder mehrere Nährstoffe aus.</v-alert>
      </v-expansion-panels>

      <div class="jetzt-searchButton" v-on:click="searchGuidanceValues" v-if="showSearchNowButton">
        <button>Jetzt suchen</button>
      </div>

    </v-row>
    </template>

    <span class="data-icon-box" v-if="showNewSearchButton">
        <img class="data-icon" src="data:image/svg+xml;base64,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" alt="Banner" v-on:click="createPDF"/>
        <img class="data-icon" src="data:image/svg+xml;base64,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" alt="Banner" v-on:click="createXLSX"/>
      </span>
    <div class="newBlock resultButton">
      <vsa-list class="lastList" v-for="currentGroup in groupsToShow" :key="currentGroup.population_group_id">
        <vsa-item>
          <vsa-heading><p class="">{{ currentGroup.name }}</p></vsa-heading>
          <vsa-content>
            <div class="notFound" v-if="filterSelectedGuidanceValuesByGroup(currentGroup).length === 0">Für diese Bevölkerungsgruppe wurden zu den ausgewählten Nährstoffen keine Referenzwerte gefunden.</div>
            <div class="table-scrollable" v-if="filterSelectedGuidanceValuesByGroup(currentGroup).length > 0">
            <table class="customTable" >
              <thead>
                    <tr>
                      <th rowspan="2" class="sticky-header">Nährstoff</th>
                      <th scope="colgroup" colspan="2" class="sticky-header">
                        Referenzwert
                      </th>
                      <th rowspan="2" class="sticky-header">Einheit</th>
                      <th rowspan="2" class="sticky-header">Bemerkung</th>
                      <th rowspan="2" class="sticky-header">Kategorie</th>
                      <th rowspan="2" class="sticky-header">FAQ</th>
                    </tr>
                    <template
                      v-if="
                        bothSexesSelected() && !isGroupFemaleOnly(currentGroup)
                      "
                    >
                      <tr>
                        <th scope="col" class="sticky-subheader">männlich</th>
                        <th scope="col" class="sticky-subheader">weiblich</th>
                      </tr>
                    </template>
                    <template v-if="!bothSexesSelected() || isGroupFemaleOnly(currentGroup)">
                      <template v-if="isGroupFemaleOnly(currentGroup)">
                        <tr>
                          <th scope="col" class="geschlecht sticky-subheader">Weiblich</th>
                        </tr>
                      </template>
                      <template v-if="!isGroupFemaleOnly(currentGroup)">
                        <tr>
                          <th scope="col" class="geschlecht sticky-subheader">{{ selectedSex().name }}</th>
                        </tr>
                      </template>
                    </template>
                  </thead>

              <template v-if="bothSexesSelected() && !isGroupFemaleOnly(currentGroup)">
                <tr v-for="gv in filterSelectedGuidanceValuesByGroup(currentGroup)" :key="gv.guidance_value_id">
                  <td v-if="nutrientByID(gv.nutrient).name === 'Vitamin C' && gv.population_group > 7 && gv.population_group < 12 ">{{ nutrientByID(gv.nutrient).name }}<sup>{{ [...gv.footnote_nutrient, ...gv.footnote_nutrient_population_group, "p"].join()}}</sup></td>
                  <td v-else-if="nutrientByID(gv.nutrient).name === 'Zink'">{{ nutrientByID(gv.nutrient).name + " " + nutrientByID(gv.nutrient).addition }}<sup>{{ [...gv.footnote_nutrient, ...gv.footnote_nutrient_population_group].join()}}</sup></td>
                  <td v-else-if="nutrientByID(gv.nutrient).name === 'Energie'">{{ nutrientByID(gv.nutrient).name + " " + nutrientByID(gv.nutrient).addition }}<sup>{{ [...gv.footnote_nutrient, ...gv.footnote_nutrient_population_group].join()}}</sup></td>
                  <td v-else-if="(nutrientByID(gv.nutrient).name === 'Eisen')&&bothSexesSelected()&&gv.population_group > 4 && gv.population_group < 10">{{ nutrientByID(gv.nutrient).name + " " + nutrientByID(gv.nutrient).addition }}<sup>{{ ["v",...gv.footnote_nutrient, ...gv.footnote_nutrient_population_group].join()}}</sup></td>
                  <td v-else>{{ nutrientByID(gv.nutrient).name }}<sup>{{ [...gv.footnote_nutrient, ...gv.footnote_nutrient_population_group].join()}}</sup></td>
                  <td>{{ gv.value }}</td>
                  <td v-if="gv.nutrient !== energyID">{{ getFemaleGuidanceValueByGroupIdAndNutrientId(gv.population_group, gv.nutrient) }}</td>
                  <td v-if="gv.nutrient === energyID">{{ getFemaleGuidanceValueByGroupIdAndNutrientIdAndAnnotation(gv.population_group, gv.nutrient, gv.annotation) }}</td>
                  <td>{{ unitByID(gv.unit).abbreviation !== 'NULL' ? unitByID(gv.unit).abbreviation : '-'}}</td>
                  <td v-if="gv.annotation.length > 0">{{nutrientByID(gv.nutrient).addition.length > 0 ? nutrientByID(gv.nutrient).addition + "; " : ""}}{{ gv.annotation }}</td>
                  <td v-else-if="gv.annotation.length > 0 && !nutrientByID(gv.nutrient).name.includes('Energie')">{{nutrientByID(gv.nutrient).addition.length > 0 ? nutrientByID(gv.nutrient).addition + "; " : ""}}{{ gv.annotation }}</td>
                  <td v-else>{{nutrientByID(gv.nutrient).name != 'Zink' ? nutrientByID(gv.nutrient).addition : ""}}</td>
                  <td>
                    <template v-if="gv.type === 'Empfohlene Zufuhr'" style="font-size: 1rem">Ⓩ</template>
                    <template v-if="gv.type === 'Schätzwert'" style="font-size: 1rem">Ⓢ</template>
                    <template v-if="gv.type === 'Richtwert'" style="font-size: 1rem">Ⓡ</template>
                    <b class="tooltip">
                    
                    <img alt="self-Logo" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOSA0SDE3VjEzSDRWMTVDNCAxNS41NSA0LjQ1IDE2IDUgMTZIMTZMMjAgMjBWNUMyMCA0LjQ1IDE5LjU1IDQgMTkgNFpNMTUgMTBWMUMxNSAwLjQ1IDE0LjU1IDAgMTQgMEgxQzAuNDUgMCAwIDAuNDUgMCAxVjE1TDQgMTFIMTRDMTQuNTUgMTEgMTUgMTAuNTUgMTUgMTBaIiBmaWxsPSJibGFjayIvPg0KPC9zdmc+DQo=" width="15" v-if="gv.type === 'Weitere Informationen'">
                    
                    <span class="tooltiptext">{{ gv.type }}</span>
                  </b></td>
                  <td>
                    <a v-if="gv.faq.length > 0" :href="gv.faq" target="blank"><img alt="self-Logo" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOSA0SDE3VjEzSDRWMTVDNCAxNS41NSA0LjQ1IDE2IDUgMTZIMTZMMjAgMjBWNUMyMCA0LjQ1IDE5LjU1IDQgMTkgNFpNMTUgMTBWMUMxNSAwLjQ1IDE0LjU1IDAgMTQgMEgxQzAuNDUgMCAwIDAuNDUgMCAxVjE1TDQgMTFIMTRDMTQuNTUgMTEgMTUgMTAuNTUgMTUgMTBaIiBmaWxsPSJibGFjayIvPg0KPC9zdmc+DQo=" width="15"></a>
                  </td>
                </tr>
              </template>
              <template v-if="!bothSexesSelected() || isGroupFemaleOnly(currentGroup)">
                <tr v-for="gv in filterSelectedGuidanceValuesByGroup(currentGroup)" :key="gv.guidance_value_id">
                  <td v-if="nutrientByID(gv.nutrient).name === 'Zink'">{{ nutrientByID(gv.nutrient).name + " " + nutrientByID(gv.nutrient).addition }}<sup>{{ [...gv.footnote_nutrient, ...gv.footnote_nutrient_population_group].join()}}</sup></td>
                  <td v-else-if="nutrientByID(gv.nutrient).name === 'Energie'">{{ nutrientByID(gv.nutrient).name + " " + nutrientByID(gv.nutrient).addition }}<sup>{{ [...gv.footnote_nutrient, ...gv.footnote_nutrient_population_group].join()}}</sup></td>
                  <td v-else>{{ nutrientByID(gv.nutrient).name }}<sup>{{ [...gv.footnote_nutrient, ...gv.footnote_nutrient_population_group].join()}}</sup></td>
                  <td colspan="2">{{ gv.value }}</td>
                  <td>{{ unitByID(gv.unit).abbreviation !== 'NULL' ? unitByID(gv.unit).abbreviation : '-'}}</td>
                  <td v-if="gv.annotation.length > 0 && !nutrientByID(gv.nutrient).name.includes('Zink')">{{nutrientByID(gv.nutrient).addition.length > 0 ? nutrientByID(gv.nutrient).addition + "; " : ""}}{{ gv.annotation }}</td>
                  <td v-else-if="gv.annotation.length > 0 && !nutrientByID(gv.nutrient).name.includes('Energie')">{{nutrientByID(gv.nutrient).addition.length > 0 ? nutrientByID(gv.nutrient).addition + "; " : ""}}{{ gv.annotation }}</td>
                  <td v-else>{{nutrientByID(gv.nutrient).addition}}</td>
                  <td>
                    <template v-if="gv.type === 'Empfohlene Zufuhr'" style="font-size: 1rem">Ⓩ</template>
                    <template v-if="gv.type === 'Schätzwert'" style="font-size: 1rem">Ⓢ</template>
                    <template v-if="gv.type === 'Richtwert'" style="font-size: 1rem">Ⓡ</template>
                    <b class="tooltip">
                    <img alt="self-Logo" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOSA0SDE3VjEzSDRWMTVDNCAxNS41NSA0LjQ1IDE2IDUgMTZIMTZMMjAgMjBWNUMyMCA0LjQ1IDE5LjU1IDQgMTkgNFpNMTUgMTBWMUMxNSAwLjQ1IDE0LjU1IDAgMTQgMEgxQzAuNDUgMCAwIDAuNDUgMCAxVjE1TDQgMTFIMTRDMTQuNTUgMTEgMTUgMTAuNTUgMTUgMTBaIiBmaWxsPSJibGFjayIvPg0KPC9zdmc+DQo=" width="15" v-if="gv.type === 'Weitere Informationen'">
                    <span class="tooltiptext">{{ gv.type }}</span>
                  </b></td>
                  <td>
                    <a v-if="gv.faq.length > 0" :href="gv.faq" target="blank"><img alt="self-Logo" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOSA0SDE3VjEzSDRWMTVDNCAxNS41NSA0LjQ1IDE2IDUgMTZIMTZMMjAgMjBWNUMyMCA0LjQ1IDE5LjU1IDQgMTkgNFpNMTUgMTBWMUMxNSAwLjQ1IDE0LjU1IDAgMTQgMEgxQzAuNDUgMCAwIDAuNDUgMCAxVjE1TDQgMTFIMTRDMTQuNTUgMTEgMTUgMTAuNTUgMTUgMTBaIiBmaWxsPSJibGFjayIvPg0KPC9zdmc+DQo=" width="15"></a>
                  </td>
                </tr>
              </template>

            </table>
            </div>
            <div class="whiteSpace"><p></p></div>
            <div class="letter-text">
              <p v-for="footnote in footnotesForPopulationGroup(currentGroup)" :key="footnote.id">
                <sup class="hochbuchstabe">{{ footnote.id }}</sup>{{
                  footnote.footnote
                }}
              </p>

            </div>
            <div class="fussnote-top">
              <img class="fussnote-icon" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI2LjUiIHN0cm9rZT0iIzM3MzczNyIvPg0KPHBhdGggZD0iTTkuNSAxMC41SDQuMzkyNThWOS42ODk0NUw3Ljk5MTIxIDQuMzYyM0g0LjQ5MDIzVjMuMzYxMzNIOS40MDIzNFY0LjE4MTY0TDUuNzg5MDYgOS40OTkwMkg5LjVWMTAuNVoiIGZpbGw9IiMzNzM3MzciLz4NCjwvc3ZnPg0K" alt="Banner" />
              <span>= Empfohlene Zufuhr</span>
            </div>
            <div class="fussnote">
              <img class="fussnote-icon" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI2LjUiIHN0cm9rZT0iIzM3MzczNyIvPg0KPHBhdGggZD0iTTkuMjg3MTEgOC43NTE5NUM5LjI4NzExIDkuMzg2NzIgOS4wNTc2MiA5Ljg4NDc3IDguNTk4NjMgMTAuMjQ2MUM4LjEzOTY1IDEwLjYwNzQgNy41MDY1MSAxMC43ODgxIDYuNjk5MjIgMTAuNzg4MUM1Ljg5MTkzIDEwLjc4ODEgNS4yMzExMiAxMC42NjI4IDQuNzE2OCAxMC40MTIxVjkuMzA4NTlDNS4wNDIzMiA5LjQ2MTU5IDUuMzg3MzcgOS41ODIwMyA1Ljc1MTk1IDkuNjY5OTJDNi4xMTk3OSA5Ljc1NzgxIDYuNDYxNTkgOS44MDE3NiA2Ljc3NzM0IDkuODAxNzZDNy4yMzk1OCA5LjgwMTc2IDcuNTc5NzUgOS43MTM4NyA3Ljc5Nzg1IDkuNTM4MDlDOC4wMTkyMSA5LjM2MjMgOC4xMjk4OCA5LjEyNjMgOC4xMjk4OCA4LjgzMDA4QzguMTI5ODggOC41NjMxNSA4LjAyODk3IDguMzM2OTEgNy44MjcxNSA4LjE1MTM3QzcuNjI1MzMgNy45NjU4MiA3LjIwODY2IDcuNzQ2MDkgNi41NzcxNSA3LjQ5MjE5QzUuOTI2MTEgNy4yMjg1MiA1LjQ2NzEyIDYuOTI3NDEgNS4yMDAyIDYuNTg4ODdDNC45MzMyNyA2LjI1MDMzIDQuNzk5OCA1Ljg0MzQyIDQuNzk5OCA1LjM2ODE2QzQuNzk5OCA0Ljc3MjQ2IDUuMDExMzkgNC4zMDM3MSA1LjQzNDU3IDMuOTYxOTFDNS44NTc3NSAzLjYyMDEyIDYuNDI1NzggMy40NDkyMiA3LjEzODY3IDMuNDQ5MjJDNy44MjIyNyAzLjQ0OTIyIDguNTAyNiAzLjU5ODk2IDkuMTc5NjkgMy44OTg0NEw4LjgwODU5IDQuODUwNTlDOC4xNzM4MyA0LjU4MzY2IDcuNjA3NDIgNC40NTAyIDcuMTA5MzggNC40NTAyQzYuNzMxNzcgNC40NTAyIDYuNDQ1MzEgNC41MzMyIDYuMjUgNC42OTkyMkM2LjA1NDY5IDQuODYxOTggNS45NTcwMyA1LjA3ODQ1IDUuOTU3MDMgNS4zNDg2M0M1Ljk1NzAzIDUuNTM0MTggNS45OTYwOSA1LjY5MzY4IDYuMDc0MjIgNS44MjcxNUM2LjE1MjM0IDUuOTU3MzYgNi4yODA5MiA2LjA4MTA1IDYuNDU5OTYgNi4xOTgyNEM2LjYzOSA2LjMxNTQzIDYuOTYxMjYgNi40NzAwNSA3LjQyNjc2IDYuNjYyMTFDNy45NTA4NSA2Ljg4MDIxIDguMzM0OTYgNy4wODM2NiA4LjU3OTEgNy4yNzI0NkM4LjgyMzI0IDcuNDYxMjYgOS4wMDIyOCA3LjY3NDQ4IDkuMTE2MjEgNy45MTIxMUM5LjIzMDE0IDguMTQ5NzQgOS4yODcxMSA4LjQyOTY5IDkuMjg3MTEgOC43NTE5NVoiIGZpbGw9IiMzNzM3MzciLz4NCjwvc3ZnPg0K" alt="Banner" />
              <span>= Schätzwert</span>
            </div>
            <div class="fussnote">
              <img class="fussnote-icon" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI2LjUiIHN0cm9rZT0iIzM3MzczNyIvPg0KPHBhdGggZD0iTTUuODExNTIgNi43MTQ4NEg2LjYyMjA3QzcuMTY1NjkgNi43MTQ4NCA3LjU1OTU3IDYuNjEzOTMgNy44MDM3MSA2LjQxMjExQzguMDQ3ODUgNi4yMTAyOSA4LjE2OTkyIDUuOTEwODEgOC4xNjk5MiA1LjUxMzY3QzguMTY5OTIgNS4xMTAwMyA4LjAzODA5IDQuODIwMzEgNy43NzQ0MSA0LjY0NDUzQzcuNTEwNzQgNC40Njg3NSA3LjExMzYxIDQuMzgwODYgNi41ODMwMSA0LjM4MDg2SDUuODExNTJWNi43MTQ4NFpNNS44MTE1MiA3LjY4MTY0VjEwLjUzMzJINC42NDQ1M1YzLjM5NDUzSDYuNjYxMTNDNy41ODIzNiAzLjM5NDUzIDguMjY0MzIgMy41NjcwNiA4LjcwNzAzIDMuOTEyMTFDOS4xNDk3NCA0LjI1NzE2IDkuMzcxMDkgNC43Nzc5OSA5LjM3MTA5IDUuNDc0NjFDOS4zNzEwOSA2LjM2MzI4IDguOTA4ODUgNi45OTY0MiA3Ljk4NDM4IDcuMzc0MDJMMTAuMDAxIDEwLjUzMzJIOC42NzI4NUw2Ljk2Mzg3IDcuNjgxNjRINS44MTE1MloiIGZpbGw9IiMzNzM3MzciLz4NCjwvc3ZnPg0K" alt="Banner" />
              <span>= Richtwert</span>
            </div>
            <div class="fussnote-bottom">
              <img class="fussnote-icon" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOSA0SDE3VjEzSDRWMTVDNCAxNS41NSA0LjQ1IDE2IDUgMTZIMTZMMjAgMjBWNUMyMCA0LjQ1IDE5LjU1IDQgMTkgNFpNMTUgMTBWMUMxNSAwLjQ1IDE0LjU1IDAgMTQgMEgxQzAuNDUgMCAwIDAuNDUgMCAxVjE1TDQgMTFIMTRDMTQuNTUgMTEgMTUgMTAuNTUgMTUgMTBaIiBmaWxsPSJibGFjayIvPg0KPC9zdmc+DQo=" alt="Banner" />
              <span><a class="faqlink" href="https://www.dge.de/index.php?id=358" target="blank">= Weitere Informationen</a></span>
            </div>
          </vsa-content>
        </vsa-item>
      </vsa-list>
    </div>
    <div class="newBlock">
    <div class="new-searchButton" v-if="showNewSearchButton">
      <button v-on:click="newSearch">Auswahl ändern</button>
    </div>
    <div class="new-searchButton refresh-searchButton" v-if="showNewSearchButton">
      <button v-on:click="newSearchClearAll">Neue Suche</button>
    </div>
    </div>
  </div>
  
</template>

<script>
import {VsaContent, VsaHeading, VsaItem, VsaList} from 'vue-simple-accordion';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
import karo_data from '../assets/data.json';
import {jsPDF} from "jspdf";
import 'jspdf-autotable';
import XLSX from 'xlsx';
import {openSansBoldBase64, openSansNormalBase64} from '../assets/OpenSans';

export default {
  name: "GuidanceValues",
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
  },
  data() {
    return {
      value: null,
      showNewSearchButton: false,
      showSearchNowButton: true,
      guidanceValuesToShow: [],
      groupsToShow: [],
      selectedGroups: [],
      selectedNutrients:[],
      babyCategoryGroups : [0,1],
      childrenCategoryGroups : [2,3,4,5,6,7],
      adolescentCategoryGroups : [7],
      adultCategoryGroups : [8,9,10,11],
      pregnantCategoryGroups : [12,13,14],
      femaleOnlyGroups: [12,13,14,15],
      zinkNutrientIDs: [38,39,40],
      zinkGeneralID: 37,
      karo_data: karo_data,
      energyID: 0,
      showWarningNoNutrientsSelected: false,
      showWarningNoGroupsSelected: false,
      showWarningNoSexesSelected: false,
      nutrientGroups: [
        {
          id: 10,
          name: 'Energie',
        },
        {
          id: 1,
          name: 'energieliefernde Nährstoffe',
          subgroups: [
            {
              id: 2, name: 'Fett', subgroups: [
                  {id:3, name : 'Fettsäuren', subgroups: [
                      {id:11, name:'Mehrfach ungesättigte Fettsäuren'}
                      ]}
                  ]
            },
          ]
        },
        {id: 4, name: 'Vitamine', subgroups: [{id: 5, name: 'Fettlösliche Vitamine'}, {id: 6, name: 'Wasserlösliche Vitamine'}]},
        {id: 7, name: 'Mineralstoffe', subgroups: [{id: 8, name: 'Mengenelemente'}, {id: 9, name: 'Spurenelemente'}]}
      ],
      footnotes: karo_data.footnotes
    };
  },
  computed: {
    // unfortunately, computed properties don't take arguments, so these functions will be very repetitive:
    nutrientGroup1SelectedIndeterminate: function() {
      const nutrientsInGroup1 = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 1 || nutrient.group === 2 || nutrient.group === 3))
      return !((nutrientsInGroup1.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup1.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup1Selected: {
      get: function () {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 1 || nutrient.group === 2 || nutrient.group === 3 || nutrient.group === 11))
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 1 || nutrient.group === 2 || nutrient.group === 3 || nutrient.group === 11))
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    nutrientGroup2SelectedIndeterminate: function() {
      const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 2 || nutrient.group === 3 || nutrient.group === 11));
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup2Selected: {
      get: function () {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 2 || nutrient.group === 3 || nutrient.group === 11));
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 2 || nutrient.group === 3 || nutrient.group === 11));
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    nutrientGroup3SelectedIndeterminate: function() {
      const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 3 || nutrient.group === 11);
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup3Selected: {
      get: function () {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 3 || nutrient.group === 11);
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 3 || nutrient.group === 11);
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    nutrientGroup4SelectedIndeterminate: function() {
      const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 4 || nutrient.group === 5 || nutrient.group === 6));
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup4Selected: {
      get: function () {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 4 || nutrient.group === 5 || nutrient.group === 6));
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 4 || nutrient.group === 5 || nutrient.group === 6));
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    nutrientGroup5SelectedIndeterminate: function() {
      const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 5);
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup5Selected: {
      get: function () {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 5);
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 5);
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    nutrientGroup6SelectedIndeterminate: function() {
      const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 6);
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup6Selected: {
      get: function () {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 6);
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 6);
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    nutrientGroup7SelectedIndeterminate: function() {
      const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 7 || nutrient.group === 8 || nutrient.group === 9));
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup7Selected: {
      get: function () {
        const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 7 || nutrient.group === 8 || nutrient.group === 9));
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => (nutrient.group === 7 || nutrient.group === 8 || nutrient.group === 9));
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    nutrientGroup8SelectedIndeterminate: function() {
      const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 8);
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup8Selected: {
      get: function () {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 8);
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 8);
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    nutrientGroup9SelectedIndeterminate: function() {
      const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 9);
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup9Selected: {
      get: function () {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 9);
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 9);
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    nutrientGroup11SelectedIndeterminate: function() {
      const nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 11);
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientGroup11Selected: {
      get: function () {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 11);
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === 11);
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
    babiesSelectedIndeterminate: function() {
      return !((this.babyCategoryGroups.every(group => this.selectedGroups.includes(group))) || (this.babyCategoryGroups.every(group => !this.selectedGroups.includes(group))));
    },
    babiesSelected: {
      get: function () {
        return this.babyCategoryGroups.every(group => this.selectedGroups.includes(group));
      },
      set: function (value) {
        if (value) {
          for(const babyGroup of this.babyCategoryGroups) {
            const index = this.selectedGroups.indexOf(babyGroup);
            if (index === -1) {
              this.selectedGroups.push(babyGroup);
            }
          }
        } else {
          for(const babyGroup of this.babyCategoryGroups) {
            const index = this.selectedGroups.indexOf(babyGroup);
            if (index > -1) {
              this.selectedGroups.splice(index, 1);
            }
          }
        }
      }
    },
    childrenSelectedIndeterminate: function() {
      return !((this.childrenCategoryGroups.every(group => this.selectedGroups.includes(group))) || (this.childrenCategoryGroups.every(group => !this.selectedGroups.includes(group))));
    },
    childrenSelected: {
      get: function () {
        return this.childrenCategoryGroups.every(group => this.selectedGroups.includes(group));
      },
      set: function (value) {
        if (value) {
          for(const childrenGroup of this.childrenCategoryGroups) {
            const index = this.selectedGroups.indexOf(childrenGroup);
            if (index === -1) {
              this.selectedGroups.push(childrenGroup);
            }
          }
        } else {
          for(const childrenGroup of this.childrenCategoryGroups) {
            const index = this.selectedGroups.indexOf(childrenGroup);
            if (index > -1) {
              this.selectedGroups.splice(index, 1);
            }
          }
        }
      }
    },
    adolescentSelectedIndeterminate: function() {
      return !((this.adolescentCategoryGroups.every(group => this.selectedGroups.includes(group))) || (this.adolescentCategoryGroups.every(group => !this.selectedGroups.includes(group))));
    },
    adolescentSelected: {
      get: function () {
        return this.adolescentCategoryGroups.every(group => this.selectedGroups.includes(group));
      },
      set: function (value) {
        if (value) {
          for(const adolescentGroup of this.adolescentCategoryGroups) {
            const index = this.selectedGroups.indexOf(adolescentGroup);
            if (index === -1) {
              this.selectedGroups.push(adolescentGroup);
            }
          }
        } else {
          for(const adolescentGroup of this.adolescentCategoryGroups) {
            const index = this.selectedGroups.indexOf(adolescentGroup);
            if (index > -1) {
              this.selectedGroups.splice(index, 1);
            }
          }
        }
      }
    },
    adultSelectedIndeterminate: function() {
      return !((this.adultCategoryGroups.every(group => this.selectedGroups.includes(group))) || (this.adultCategoryGroups.every(group => !this.selectedGroups.includes(group))));
    },
    adultSelected: {
      get: function () {
        return this.adultCategoryGroups.every(group => this.selectedGroups.includes(group));
      },
      set: function (value) {
        if (value) {
          for(const adultGroup of this.adultCategoryGroups) {
            const index = this.selectedGroups.indexOf(adultGroup);
            if (index === -1) {
              this.selectedGroups.push(adultGroup);
            }
          }
        } else {
          for(const adultGroup of this.adultCategoryGroups) {
            const index = this.selectedGroups.indexOf(adultGroup);
            if (index > -1) {
              this.selectedGroups.splice(index, 1);
            }
          }
        }
      }
    },
    pregnantsSelectedIndeterminate: function() {
      return !((this.pregnantCategoryGroups.every(group => this.selectedGroups.includes(group))) || (this.pregnantCategoryGroups.every(group => !this.selectedGroups.includes(group))));
    },
    pregnantsSelected: {
      get: function () {
        return this.pregnantCategoryGroups.every(group => this.selectedGroups.includes(group));
      },
      set: function (value) {
        if (value) {
          for(const pregnantGroup of this.pregnantCategoryGroups) {
            const index = this.selectedGroups.indexOf(pregnantGroup);
            if (index === -1) {
              this.selectedGroups.push(pregnantGroup);
            }
          }
        } else {
          for(const pregnantGroup of this.pregnantCategoryGroups) {
            const index = this.selectedGroups.indexOf(pregnantGroup);
            if (index > -1) {
              this.selectedGroups.splice(index, 1);
            }
          }
        }
      }
    },
    // ab hier nährstoffe
    nutrientClass0SelectedIndeterminate: function() {
      //filter nutrients by group:
      return this.generalNutrientClassSelectedIndeterminate(0);
      // let nutrientsClass0 = this.nutrients.filter(nutrient => nutrient.group === 0);
      // return !((nutrientsClass0.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsClass0.every(group => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    nutrientClass1SelectedIndeterminate: function() {
      return this.generalNutrientClassSelectedIndeterminate(1);
    },
    nutrientClass2SelectedIndeterminate: function() {
      return this.generalNutrientClassSelectedIndeterminate(2);
    },
    nutrientClass3SelectedIndeterminate: function() {
      return this.generalNutrientClassSelectedIndeterminate(3);
    },
    nutrientClass4SelectedIndeterminate: function() {
      return this.generalNutrientClassSelectedIndeterminate(4);
    },
    nutrientClass5SelectedIndeterminate: function() {
      return this.generalNutrientClassSelectedIndeterminate(5);
    },
    nutrientClass6SelectedIndeterminate: function() {
      return this.generalNutrientClassSelectedIndeterminate(6);
    },
    nutrientClass7SelectedIndeterminate: function() {
      return this.generalNutrientClassSelectedIndeterminate(7);
    },
    nutrientClass8SelectedIndeterminate: function() {
      return this.generalNutrientClassSelectedIndeterminate(8);
    },
    nutrientClass9SelectedIndeterminate: function() {
      return this.generalNutrientClassSelectedIndeterminate(9);
    },
    nutrientClass6Selected: {
      get: function () {
        const nutrientGroupID = 6;
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === nutrientGroupID);
        return nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id));
      },
      set: function (value) {
        const nutrientGroupID = 6;
        let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === nutrientGroupID);
        if (value) {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index === -1) {
              this.selectedNutrients.push(nutrient.nutrient_id);
            }
          }
        } else {
          for(const nutrient of nutrientsInGroup) {
            const index = this.selectedNutrients.indexOf(nutrient.nutrient_id);
            if (index > -1) {
              this.selectedNutrients.splice(index, 1);
            }
          }
        }
      }
    },
  },


  methods: {
    generalNutrientClassSelectedIndeterminate: function(groupId) {
      let nutrientsInGroup = this.karo_data.nutrients.filter(nutrient => nutrient.group === groupId);
      return !((nutrientsInGroup.every(nutrient => this.selectedNutrients.includes(nutrient.nutrient_id))) || (nutrientsInGroup.every(nutrient => !this.selectedNutrients.includes(nutrient.nutrient_id))));
    },
    getFootnotesForGuidanceValue: function(guidanceValue) {
      let returnValue = [...guidanceValue.footnote_nutrient, ...guidanceValue.footnote_nutrient_population_group].filter(x => x.length > 0).join();
      return returnValue;
    },
    footnotesForPopulationGroup: function(group) {
      const groupId = group.population_group_id;
      let footnotesToShow = [];
      this.guidanceValuesToShow.forEach((value) => {
        if(value.population_group === groupId) {
          footnotesToShow = [...footnotesToShow, ...value.footnote_nutrient, ...value.footnote_nutrient_population_group];
        }
      });

      let fn = this.footnotes.filter(function(footnote) {
        return footnotesToShow.includes(footnote.id);
      });
      return fn;
    },
    filterSelectedGuidanceValuesByGroup: function (group) {      
      if(this.bothSexesSelected() && !this.femaleOnlyGroups.includes(group.population_group_id)) {
       return this.guidanceValuesToShow.filter(function(gv) {
              return (gv.population_group === group.population_group_id && gv.sex === karo_data.sexes[0].sex_id)
            }
        );
      } else {
        return this.guidanceValuesToShow.filter(function(gv) {
              return (gv.population_group === group.population_group_id)
            }
        );
      }
    },
    isGroupFemaleOnly: function(group) {
      return this.femaleOnlyGroups.includes(group.population_group_id);
    },
    getFemaleGuidanceValueByGroupIdAndNutrientId: function(group, nutrient) {
      return this.guidanceValuesToShow.filter(function(gv) {
        return (gv.population_group === group && gv.nutrient === nutrient && gv.sex === karo_data.sexes[1].sex_id)
          }
      )[0].value;
    },
    getFemaleGuidanceValueByGroupIdAndNutrientIdAndAnnotation: function(group, nutrient, annotation) {
      return this.guidanceValuesToShow.filter(function(gv) {
            return (gv.population_group === group && gv.nutrient === nutrient && gv.annotation === annotation && gv.sex === karo_data.sexes[1].sex_id)
          }
      )[0].value;
    },
    nutrientsForGroup: function (groupID) {
      return this.karo_data.nutrients.filter(nutrient => nutrient.group === groupID && !this.zinkNutrientIDs.includes(nutrient.nutrient_id))
    },
    nutrientByID: function (nutrientID) {
      return this.karo_data.nutrients.filter(nutrient => nutrient.nutrient_id === nutrientID)[0]
    },
    sexByID: function (sexID) {
      return this.karo_data.sexes.filter(sex => sex.sex_id === sexID)[0]
    },
    unitByID: function (unitID) {
      return this.karo_data.units.filter(unit => unit.unit_id === unitID)[0]
    },
    bothSexesSelected: function() {
      return karo_data.sexes[0].selected && karo_data.sexes[1].selected;
    },
    selectedSex: function() {
      return karo_data.sexes.filter(function(sex) {
        return sex.selected === true;
      })[0];
    },
    newSearch: function() {
      this.showNewSearchButton = false;
      this.showSearchNowButton = true;
      this.guidanceValuesToShow = [];
      this.groupsToShow = [];
    },
    newSearchClearAll: function() {
      this.showNewSearchButton = false;
      this.showSearchNowButton = true;
      this.guidanceValuesToShow = [];
      this.groupsToShow = [];
      this.selectedGroups = [];
      this.selectedNutrients = [];
      this.karo_data.sexes[0].selected = true;
      this.karo_data.sexes[1].selected = true;

    },

    searchGuidanceValues: function() {
      let self = this;
      // edge case for Zink; add all zink nutrient ids to selected nutrients if zink is selected

      if(this.selectedNutrients.includes(this.zinkGeneralID)) {
        this.selectedNutrients = [...this.selectedNutrients, ...this.zinkNutrientIDs];
      }
      
      // edge case for energy
      if(this.selectedNutrients.includes(this.energyID)) {
        const energyNutrients = this.karo_data.nutrients.filter(nutrient => nutrient.group === 10 && nutrient.nutrient_id != 0);
        let energyNutrientIDs = [];
        for (let energyNutrient of energyNutrients) {
          energyNutrientIDs.push(energyNutrient.nutrient_id)
        }
        this.selectedNutrients = [...this.selectedNutrients, ...energyNutrientIDs];
      }
      else{
        const energyNutrients = this.karo_data.nutrients.filter(nutrient => nutrient.group === 10 && nutrient.nutrient_id != 0);
        let energyNutrientIDs = [];
        for (let energyNutrient of energyNutrients) {
          energyNutrientIDs.push(energyNutrient.nutrient_id)
        }

        for(let i = 0; i < energyNutrientIDs.length; i++){
          let index = this.selectedNutrients.indexOf(energyNutrientIDs[i]);
          if(index > -1){
            this.selectedNutrients.splice(index, 1);
          }
        }
      }

      if (this.selectedGroups.length === 0 || this.selectedNutrients.length === 0) {
        if (this.selectedGroups.length === 0) {
          this.showWarningNoGroupsSelected = true;
          setTimeout(function () {
            self.showWarningNoGroupsSelected = false;
          }, 5000);
        }
        if(this.karo_data.sexes[0].selected === false && this.karo_data.sexes[1].selected === false) {
          this.showWarningNoSexesSelected = true;
          setTimeout(function () {
            self.showWarningNoSexesSelected = false;
          }, 5000);
        }
        if (this.selectedNutrients.length === 0) {
          this.showWarningNoNutrientsSelected = true;
          setTimeout(function () {
            self.showWarningNoNutrientsSelected = false;
          }, 5000);
        }
        return
      }
      if(this.karo_data.sexes[0].selected === false && this.karo_data.sexes[1].selected === false) {
          this.karo_data.sexes[0].selected = true;
          this.karo_data.sexes[1].selected = true;
        }

      this.showSearchNowButton = false;
      this.showNewSearchButton = true;
      this.guidanceValuesToShow.length = 0;
      this.groupsToShow.length = 0;

      let selectedGroups = [];
      let selectedSexIDs = [];

      for (const group of karo_data.population_groups) {
        if (this.selectedGroups.includes(group.population_group_id)) {
          selectedGroups.push(group);
        }
      }

      for (const sex of karo_data.sexes) {
        if (sex.selected) {
          selectedSexIDs.push(sex.sex_id);
        }
      }

      if(selectedSexIDs.length == 0){
        selectedSexIDs = [1,2];
      }

      let selectedGuidanceValues = [];
      for (const guidanceValue of karo_data.guidance_values) {
        if(this.selectedNutrients.includes(guidanceValue.nutrient) && this.selectedGroups.includes(guidanceValue.population_group) && selectedSexIDs.includes(guidanceValue.sex)) {
          selectedGuidanceValues.push(guidanceValue);
        }
      }

      this.groupsToShow = selectedGroups;
      this.guidanceValuesToShow = selectedGuidanceValues;
      //dont know why this doesnt sort it properly.. defaulting to good old bubble sort
      // this.guidanceValuesToShow.sort((guidanceValue1, guidanceValue2) => {
      //   guidanceValue1.nutrient - guidanceValue2.nutrient; 
      // });

      for(let i = 0; i < this.guidanceValuesToShow.length; i++){
        for(let j = 0; j < this.guidanceValuesToShow.length-i-1; j++){
          if(this.guidanceValuesToShow[j].nutrient > this.guidanceValuesToShow[j+1].nutrient){
            let temp = this.guidanceValuesToShow[j];
            this.guidanceValuesToShow[j] = this.guidanceValuesToShow[j+1];
            this.guidanceValuesToShow[j+1] = temp;
          }
        }

        //iron special case
        // if(this.guidanceValuesToShow[i].nutrient == 34){
        //   console.log(this.guidanceValuesToShow[i])
        //   console.log([...this.guidanceValuesToShow[i].footnote_nutrient, ...this.guidanceValuesToShow[i].footnote_nutrient_population_group].join())
        // }
      }
    },
    createPDF: function() {
      const doc = new jsPDF();

      doc.addFileToVFS("OpenSans-Regular-normal.ttf", openSansNormalBase64);
      doc.addFont("OpenSans-Regular-normal.ttf", "OpenSans", "normal");
      // test change
      doc.addFileToVFS("OpenSans-Bold-bold.ttf", openSansBoldBase64);
      doc.addFont("OpenSans-Bold-bold.ttf", "OpenSans", "bold");
      doc.setFont("OpenSans", "bold");
      const logoBase64 = 'data:image/png;base64,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\n';
      const data = this.karo_data;
      const guidanceValues = this.guidanceValuesToShow;

      //let firstTable = true;
      let totalFootnotes = [];
      doc.setFontSize(15);
      doc.setTextColor(34, 34, 34);
      doc.text('Übersicht über die D-A-CH-Referenzwerte', 14, 28);
      doc.setFontSize(11);
      doc.setFont("OpenSans", "normal");
      doc.setTextColor("#000000");
      doc.text('In dieser Tabelle finden Sie die auf Ihre Filtersuche angepassten Daten.', 14, 33);
      doc.setFont("OpenSans", "bold");
      this.groupsToShow.forEach(function(group) {
        doc.text(14, 38, group.name, doc.lastAutoTable);

        const guidanceValuesForGroupMale = guidanceValues.filter(guidanceValue => guidanceValue.population_group === group.population_group_id && guidanceValue.sex === 1);
        const guidanceValuesForGroupFemale = guidanceValues.filter(guidanceValue => guidanceValue.population_group === group.population_group_id && guidanceValue.sex === 2);
        // filter sexes
        let guidanceValuesForGroup = [];
        if (data.sexes[0].selected) {
          guidanceValuesForGroup = [...guidanceValuesForGroup, ...guidanceValuesForGroupMale];
        }
        if (data.sexes[1].selected) {
          guidanceValuesForGroup = [...guidanceValuesForGroup, ...guidanceValuesForGroupFemale];
        }
        let pdfdata = [];
        let footnotes = [];
        for(const value of guidanceValuesForGroup) {
          let populationGroup = data.population_groups.filter(population_group => population_group.population_group_id === value.population_group)[0].name;
          const sex = data.sexes.filter(sex => sex.sex_id === value.sex)[0].name;
          populationGroup = populationGroup + " (" + sex + ")"
          const nutrientObject = data.nutrients.filter(nutrient => nutrient.nutrient_id === value.nutrient)[0];
          const nutrient = nutrientObject.name
          const guidanceValue = value.value;
          let unit = data.units.filter(unit => unit.unit_id === value.unit)[0].abbreviation;
          if (unit === 'NULL') {
            unit = '-';
          }
          let annotation;
          if (nutrientObject.addition.length > 0) {
            if (value.annotation.length > 0) {
              annotation = nutrientObject.addition + "; " + value.annotation;
            } else {
              annotation = nutrientObject.addition;
            }
          } else {
            annotation = value.annotation;
          }
          const type = (value.type === "NULL") ? "-" : value.type;
            
          const footnotes_array = [...value.footnote_nutrient, ...value.footnote_nutrient_population_group];
          for(const footnote of footnotes_array) {
            if(!footnotes.includes(footnote) && footnote.length > 0) {
              footnotes.push(footnote.trim());
            }
          }
          totalFootnotes = [...totalFootnotes, ...footnotes];
          const footnotes_string = footnotes_array.join();
          // In pdfdata sind nun sämtliche Daten, die für die jeweilige Gruppe relevant sind.
          pdfdata.push([nutrient, sex, guidanceValue, unit, annotation, type, footnotes_string]);
        }


        //doc.setTextColor("#808080");

        doc.autoTable({
          head: [['Nährstoff', 'Geschlecht', 'Referenz-\nwert', 'Einheit', 'Anmerkung', 'Referenzwert-\ntyp', 'Fußnoten']],
          body: pdfdata,
          margin: { top: 45 },
          theme: 'grid',
          styles: {
            font:"OpenSans",
            fontStyle:"normal"
          },
          headStyles: {
            font:"OpenSans",
            fontStyle:"bold",
            fontSize: 9,
            fillColor: [250, 252, 240],
            textColor: [55, 55, 55],
            halign: 'left',
        },
        });
        doc.addPage();
      });


      totalFootnotes = [...(new Set(totalFootnotes))].sort();
      let totalFootnotesWithAnnotation = [];
      for(const fn of totalFootnotes) {
        // get annotation:
        const fn_data = data.footnotes.filter(footnote => footnote.id === fn)[0];
        totalFootnotesWithAnnotation.push([fn, fn_data.footnote]);
      }
      doc.autoTable({
        head: [['Fußnote', 'Erklärung']],
        body: totalFootnotesWithAnnotation,
        margin: { top: 45 },
        theme: 'grid',
        styles: {
          font:"OpenSans",
          fontStyle:"normal"
        },
        headStyles: {
          font:"OpenSans",
          fontStyle:"bold",
          fontSize: 10,
          fillColor: [250, 252, 240],
          textColor: [55, 55, 55],
          halign: 'left',
        },
      });

      // now that we have all pages, add headers to the pages
      const pageCount = doc.internal.getNumberOfPages();
      for(let i = 0; i < pageCount; i++) {
        doc.setPage(i);
        // header
        // dge green
        doc.setTextColor("#418a4d");
        doc.setLineWidth(0.25)
        doc.line(25, 22, 185, 22)
        doc.setFontSize(10);
        doc.text('D-A-CH-Referenzwerte für die Nährstoffzufuhr', 26, 20);

        if (i === 1) {
          doc.addImage(logoBase64, 'PNG', 178.4, 5, 15.4, 15.8);
        }

        //end header
        //footer, add page numbers
        doc.setFontSize(8);
        const currentPageNumberCorrectOffset = i === 0 ? pageCount : i;
        doc.text("Seite " + currentPageNumberCorrectOffset + " von " + pageCount, 180, 285);
      }

      doc.save("referenzwerte.pdf");

    },
    createXLSX: function() {
      let workbook = XLSX.utils.book_new();

      const ws_data = [
        [ "Bevölkerungsgruppe", "Geschlecht", "Nährstoff", "Referenzwert", "Einheit", "Bemerkung", "Kategorie", "Fussnoten" ],
      ];
      let footnotes = [];

      const guidanceValuesForGroupMale = this.guidanceValuesToShow.filter(guidanceValue => guidanceValue.sex === 1);
      const guidanceValuesForGroupFemale = this.guidanceValuesToShow.filter(guidanceValue => guidanceValue.sex === 2);
      let filteredGuidanceValues = [];
      if (this.karo_data.sexes[0].selected) {
        filteredGuidanceValues = [...filteredGuidanceValues, ...guidanceValuesForGroupMale];
      }
      if (this.karo_data.sexes[1].selected) {
        filteredGuidanceValues = [...filteredGuidanceValues, ...guidanceValuesForGroupFemale];
      }
      for(const value of filteredGuidanceValues) {
        let populationGroup = this.karo_data.population_groups.filter(population_group => population_group.population_group_id === value.population_group)[0].name;
        const sex = this.karo_data.sexes.filter(sex => sex.sex_id === value.sex)[0].name;
        populationGroup = populationGroup + " (" + sex + ")"
        const nutrientObject = this.karo_data.nutrients.filter(nutrient => nutrient.nutrient_id === value.nutrient)[0];
        const nutrient = nutrientObject.name
        const guidanceValue = value.value;
        let unit = this.karo_data.units.filter(unit => unit.unit_id === value.unit)[0].abbreviation;
        if (unit === "NULL") {
          unit = '-';
        }
        let annotation;
        if (nutrientObject.addition.length > 0) {
          if (value.annotation.length > 0) {
            annotation = nutrientObject.addition + "; " + value.annotation;
          } else {
            annotation = nutrientObject.addition;
          }
        } else {
          annotation = value.annotation;
        }
        const type = (value.type === "NULL") ? "-" : value.type;
        const footnotes_array = [...value.footnote_nutrient, ...value.footnote_nutrient_population_group];
        for(const footnote of footnotes_array) {
          if(!footnotes.includes(footnote)) {
            footnotes.push(footnote);
          }
        }
        const footnotes_string = footnotes_array.join();
        ws_data.push([populationGroup, sex, nutrient, guidanceValue, unit, annotation, type, footnotes_string]);
      }


      const worksheet = XLSX.utils.aoa_to_sheet(ws_data);

      const full_footnotes = this.footnotes.filter(footnote => footnotes.includes(footnote.id));
      let full_footnotes_array = [];
      for (const full_footnote of full_footnotes) {
        full_footnotes_array.push([full_footnote.id, full_footnote.footnote]);
      }
      const footnote_worksheet_data = [["Fußnote", "Beschreibung"], ...full_footnotes_array];
      const footnote_worksheet = XLSX.utils.aoa_to_sheet(footnote_worksheet_data);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Referenzwerte");
      XLSX.utils.book_append_sheet(workbook, footnote_worksheet, "Fußnoten");
      XLSX.writeFile(workbook, 'Referenzwerte.xlsx');
    }
  }
}

</script>

<style scoped>
/* hier kommt euer CSS rein */

table,
th,
tr,
td {
  border: 1px solid black;
}
.leftList,
.rightList {
  float: left;
  display: inline;
  width: 47.65%;
}
.searchButton {
  display: block;
  padding-top: 80px;
}



/* -------------------------- Anfang NeuerCode -----------------------------*/
/*Zielgruppen Hover entfernen*/
@media only screen and (max-width: 669px) {

.leftList {
  margin-bottom: 20px;
  width: 100%;
}
  .rightList {
    margin-bottom: 20px;
    width: 100%;
  }
  .leftList {
    margin-right: 0px !important;
  }
}

.leftList {
  margin-right: 30px;
}

.rootList{
  background-color: #068F4B;
}

.rootList >>> .vsa-list, .leftList >>> .vsa-list  {
  --vsa-bg-color: #FAFCF0;
}

.rootList .vsa-item__content > div {
  padding: 10px;
  text-align: left;
}

.lastList >>> dt.vsa-item__heading {
  background-color: #068F4B;
}

.lastList >>> dt.vsa-item__trigger__content {
  color: #fff;
}

.lastList {
  margin-top: 20px;
  display: inline-block;
}

.data-icon-box {
  float: left;
}

.lastList >>> .vsa-item__content {
  padding: 0;
  padding-top: 20px;
}

.notFound {
  /* border: 1px solid #e2e2e2;
  border-top: none; */
  padding: 10px;
}

.lastList a {
  color: #fff;
}

.tabelle >>> .vsa-item__content >>> div.letter-text p {
  margin-bottom: 15px;
}

.newBlock div.letter-text p {
  margin-bottom: 15px;
}

/* -------------------------- Ende NeuerCode -----------------------------*/

</style>

<style>
/* -------------------------- Anfang Allgemein -----------------------------*/
#app h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: "Open Sans", sans-serif;
}

#app tr,
th {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
}

#app td {
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  word-break: break-word;
}

#app .body {
  max-width: 670px;
}

#app .newBlock {
  padding: 20px;
  margin: 0;
  padding-top: 0px;
}

#app html::-webkit-scrollbar {
    display: none;
}

#app {
  margin-top: 0 !important;
}

#app .einruecken {
  padding-left: 49px;
}

#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div.v-expansion-panel-content > div > div.v-expansion-panel.secondEbene.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div.v-expansion-panel-content > div > div.v-expansion-panel.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div > div > div.v-expansion-panel.secondLvl.v-expansion-panel--active.v-item--active > div > div > div:nth-child(1),
#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div.v-expansion-panel-content > div > div.v-expansion-panel.secondEbene.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div.v-expansion-panel-content > div > div.v-expansion-panel.secondLvl.v-expansion-panel--active.v-item--active > div > div > div.v-expansion-panel.secondLvl > div > div > div:nth-child(1) {
  display: none !important;
}

/* -------------------------- Ende Allgemein -----------------------------*/

/* -------------------------- Anfang Intro Text -----------------------------*/
#app h1 {
  font-size: 20pt;
  text-align: left;
  padding-left: 20px;
}

#app .fliesstext {
  font-size: 11pt;
  text-align: left;
  margin-top: 20px;
  margin-left: 20px;
}

#app .rootList .vsa-item__trigger:focus, .vsa-list:focus{
  background: #068F4B;
}

/* .rootList .vsa-item__trigger {
  border-bottom: 1px solid #e2e2e2
} */

.rootList .vsa-item__trigger:hover {
  color: black;
}

.rootList .vsa-item__trigger__content {
  text-align: left;
}

.rootList .vsa-item__trigger:hover {
  background-color: #068F4B;
  color: #fff;
}

.vsa-item__trigger:focus, .vsa-item__trigger:hover {
    outline: none;
    background-color: #068F4B;
    color: var(--vsa-bg-color);
}

.jetzt-searchButton, .new-searchButton {
text-align: center !important;
float: left;
margin-top: 20px;
width: 100%;
height: 50px;
}

#app .new-searchButton{
  padding-right: 10px;
  width: 50% !important;
}

#app .refresh-searchButton{
  padding-left: 10px;
  padding-right: 0px !important;
}

#app .jetzt-searchButton button, .new-searchButton button  {
  background-color: #068F4B;
  border: none;
  color: white;
  font-family: 'Open Sans', sans-serif;
  font-size: 14pt;
  font-weight: 600;
  width: 100%;
  height: 50px;
  border-radius: 0.3em;
}

#app .new-searchButton {
  margin-top: 0;
}
/* kein #app selektor */
.vsa-item__trigger__icon.vsa-item__trigger__icon--is-default {
  content: none;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #fff;
  margin-top: 3.5px;
  margin-right: 2px;
}

#app .new-searchButton {
  margin-top: 0;
}
/* kein #app selektor */
.vsa-item__trigger__icon.vsa-item__trigger__icon--is-default {
  content: none;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #fff;
  margin-top: 3.5px;
  margin-right: 2px;
}
/* -------------------------- Ende Intro Text -----------------------------*/

/* -------------------------- Anfang Responsive-----------------------------*/

@media only screen and (max-width: 669px) {

  #app .jetzt-searchButton, .new-searchButton {
text-align: center !important;
float: left;
margin-top: 0;
width: 100%;
height: 50px;
}

#app .leftList .v-expansion-panels {
  width: 100% !important;
  margin-right:0;
}
#app .rightList .v-expansion-panels {
    width: 100% !important;
  margin-right:0;
}
 #app tr {
   font-size: calc(10px + (26 - 15) * ((100vw - 300px) / (1600 - 300)));
 }
}

#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > button > div > i,
#app > div > main > div > div > div.row > div.leftList.v-item-group.theme--light.v-expansion-panels > div > div:nth-child(1) > button > div > i {
  color: white !important;
}

/* -------------------------- Ende Responsive-----------------------------*/

/* -------------------------- Anfang Zielgruppe / Leftlist -----------------------------*/

#app .genderLabel {
display: inline-flex;

}

/* .gender label {
  margin: auto;
  margin-right: 25px;
  font-size: 11.25pt;
}
.gender input{
  margin-right: 16px;
}

.gender b {
  font-weight: 400;
}

.gender {
  border-bottom: 1px solid #e2e2e2;
  background: #fafcf0;
  width: 100%;
  padding-left: 24px !important;
  padding: 11px;
} */

#app .data-icon {
  width: 72px;
  padding-left: 20px;
}

#app .vsa-list {
  min-width: 10%;
  border: none;
}

#app .leftList,
.rightList {
  border: none;
}

/* -------------------------- Ende Zielgruppe / leftList -----------------------------*/

/* -------------------------- Anfang Tabelle -----------------------------*/

#app .resultButton .vsa-item__trigger__content {
  font-family: "Open Sans", sans-serif;
  font-size: 12pt;
}

/* Responsive_Styling der Tabelle */

#app .sticky-header {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  color: black;
  background: #fff;
  z-index: 3;
}

#app .sticky-subheader {
  position: sticky;
  position: -webkit-sticky;
  top: 30px;
  color: black;
  background: #ffffff;
  z-index: 3;
}

/* thead {
  display: table; /* to take the same width as tr */

#app .table-scrollable::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
}

#app .table-scrollable::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 3px solid #fff;
}

#app th {
  font-size: 9pt;
}

#app td {
  max-width: 100%;
  font-size: 9pt;
}

#app table.customTable {
  width: 100%;
  background-color: #ffffff;
  border-collapse: separate;
  border-width: 1px;
  border-color: #e2e2e2;
  border-style: solid;
  color: #000000;
  border-top: none;
  border-bottom: none;
  display: block;
  overflow-x: auto;
  overflow-y: auto;
  height: 400px;
  border-spacing: 0;
}

#app table.customTable td,
table.customTable th {
  border-width: 1px;
  border-color: #e2e2e2;
  border-style: solid;
  padding: 5px;
  text-align: center;
}

#app .geschlecht {
  font-size: 12px;
}

#app .whiteSpace {
  height: 50px;
  border: 1px solid #e2e2e2;
  border-top: 1px solid #fff;

  margin: 0 !important;
  padding: 0;
}

#app .hochbuchstabe {
  font-size: 9pt;
  font-weight: 600;
  padding-right: 5px;
}

/* Fußnoten unter der Tabelle */

#app .fussnote-top {
  display: flex;
  padding-top: 10px;
  padding-left: 0;
  padding-bottom: 0;
  font-family: "Open Sans", sans-serif;
  font-size: 9pt;
  font-weight: 600;
}

#app .fussnote {
  display: flex;
  font-family: "Open Sans", sans-serif;
  font-size: 9pt;
  font-weight: 600;
  padding-top: 5px;
}

#app .fussnote-bottom {
  display: flex;
  font-family: "Open Sans", sans-serif;
  font-size: 9pt;
  font-weight: 600;
  padding-top: 5px;
  padding-bottom: 20px;
}

#app .fussnote-icon {
  margin-right: 6px;
  width: 15px;
}

#app .letter-text {
  text-align: left;
  font-family: "Open Sans", sans-serif;
  font-size: 9pt;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  border: 1px solid #e2e2e2;
  border-top: none;
}

#app .first-letter {
  margin: 0 !important;
}

/* -------------------------- Ende Tabelle -----------------------------*/

/* -------------------------- Anfang DropDown Icons -----------------------------*/

/** I came here to chew bubblegum and kick ass, but im all out of bubblegum **/

#app .vsa-item__trigger__icon.vsa-item__trigger__icon--is-default {
  content: none;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #a9a9a9;
  margin-top: 3.5px;
  margin-right: 2px;
}

#app .vsa-item__trigger__icon--is-default:after,
.vsa-item__trigger__icon--is-default:before {
  content: none;
}

#app .vsa-item__trigger[aria-expanded="true"] .vsa-item__trigger__icon--is-default {
  transform: rotate(-90deg) translate3d(0px, 0px, 0);
}

#app .vsa-item--is-active .vsa-item__heading,
.vsa-item:not(:last-of-type) {
  border: none;
}

/* -------------------------- Ende DropDown Icons -----------------------------*/

#app .test {
  color: #ffffff;
  font-size: 14pt;
}

#app .rootList .vsa-item__content {
  padding: 0;
  background-color: #FAFCF0;
}

/* .rootList dd {
  border: 1px solid #e2e2e2;
  border-bottom: 0;
  border-top: 0;
} */

/* Tooltip container */
#app .tooltip {
  position: relative;
  display: block;
}

/* Tooltip text */
#app .tooltip .tooltiptext {
  visibility: hidden;
  background-color: #068f4b;
  color: #fff;
  text-align: center;
  padding: 5px;
  font-size: 8pt;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
  left: -25px;
}

/* Show the tooltip text when you mouse over the tooltip container */
#app .tooltip:hover .tooltiptext {
  visibility: visible;
}

#app .protein-info {
  font-size: 8pt;
  color: #068f4b;
  margin-top: -15px;
}



#app .resultButton .vsa-item__trigger__content {
  font-family: "Open Sans", sans-serif;
  font-size: 12pt;
}

#app .vsa-list label {
  justify-content: center;
  align-items: left;
  font-family: "Open Sans", sans-serif;
  font-size: 12pt;
}

#app .stillEnde .vsa-list {
  display: flex;
  flex-wrap: wrap;
  position: left;
  padding-left: 10px;
}

#app .lastList .vsa-item__content {
  padding-top: 0 !important;
}

#app .lastList .vsa-item__trigger p, .lastList .vsa-item__trigger p:hover, .lastList .vsa-item__trigger p:active {
  color: #373737;
}

#app .lastList .vsa-item__trigger {
  background-color: #FAFCF0;
  border: 1px solid #e2e2e2;
}
/*expansion panel style overrides*/
/*Styles werden angenommen, wenn die CSS Selektoren spezifischer als die mitgelieferten sind, zB mit einem zusätzlichen*/
/*Verweis auf die ID des umschließenden Elements: */

#app .targetGroupsExpansionPanel .v-expansion-panel-header {
  color: white;
}

#app .InnerPanels .v-expansion-panel-header {
  color: black;
  background-color: #FAFCF0;
}

#app .v-application .green {
  background-color: blue !important;
}

#app .heading {
  background-color: #068F4B;
}

#app .v-expansion-panel-content__wrap {
  padding: 0 !important;
  /* border-left: 1px solid #e2e2e2;
  border-right: 1px solid #e2e2e2; */
}

#app .v-expansion-panel-content__wrap > div {
  border-left: none;
  border-right:none;
  /* border-bottom: 1px solid #e2e2e2; */
}

#app .v-expansion-panel--active:not(:first-child), .v-expansion-panel--active + .v-expansion-panel {
  margin: 0 !important;
}

#app .v-expansion-panel::before {
  box-shadow: none !important;
}

#app .v-expansion-panel-content__wrap {
  background-color: #FAFCF0;
}

/* .leftList .v-expansion-panel-content__wrap > div:first-of-type {
  border-top: 1px solid #e2e2e2;
}

.leftList .v-expansion-panel-content__wrap > div {
  border-top: 1px solid #e2e2e2;
}

.v-expansion-panel-content__wrap > div {
  border-bottom: 1px solid #e2e2e2;
}

.rightList .v-expansion-panel-header {
  border-bottom: 1px solid #e2e2e2;
} */

#app .v-expansion-panel-content__wrap > div:last-of-type {
  border-bottom: none;
}

 #app .body > .row{
  margin:0 15px 0 15px !important;
 }

 #app .leftList .row{
  margin:0 0 0 0 !important;
 }



#app .rightList .InnerPanels .v-expansion-panel-content__wrap > div .v-expansion-panel-content__wrap {

align-items: center;
    min-height: 48px;
     font-size: 0.9375rem;
    line-height: 1;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;

}

/* .rightList .InnerPanels .v-expansion-panel-content__wrap > div .v-expansion-panel-content__wrap > div {

align-items: center;
    min-height: 48px;
     font-size: 0.9375rem;
    line-height: 1;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;

} */

#app .rightList .InnerPanels .v-expansion-panel-content__wrap:last-of-type > div:last-of-type:not(.v-expansion-panel),
.rightList .InnerPanels .v-expansion-panel-content__wrap:last-of-type > div:nth-last-of-type(2):not(.v-expansion-panel),
.rightList .InnerPanels .v-expansion-panel-content__wrap:last-of-type > div:nth-last-of-type(3):not(.v-expansion-panel) {
    align-items: center;
    /* border-top-left-radius: inherit;
    border-top-right-radius: inherit; */
    display: flex;
    font-size: 0.9375rem;
    line-height: 1;
    min-height: 48px;
    outline: none;
    padding: 16px 0px 16px 48px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    /* border-bottom: 1px solid #e2e2e2; */
}

#app .rightList .InnerPanels .v-expansion-panel-content__wrap:last-of-type > div:last-of-type:not(.v-expansion-panel) .firstLabel {
  border-bottom: 1px solid #e2e2e2;
}

/* Für: "Stillende" kommt ein mal zu viel vor, selector ändern  */
#app .leftList .v-expansion-panel-content__wrap:last-of-type > div:last-of-type {
      align-items: center;
    /* border-top-left-radius: inherit;
    border-top-right-radius: inherit; */
    display: flex;
    font-size: 0.9375rem;
    line-height: 1;
    min-height: 48px;
    outline: none;
    padding: 16px 0px 16px 48px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    border-bottom: 1px solid #e2e2e2;
}

/* Für: "protein linolsäure etc" kommt ein mal zu viel vor, selector ändern  */
#app .rightList .v-expansion-panel-content__wrap:first-child > label, .rightList .v-expansion-panel-content__wrap:first-child > label {
    align-items: center;
    display: flex;
    font-size: 0.9375rem;
    line-height: 1;
    min-height: 48px;
    outline: none;
    padding: 16px 0px 16px 48px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    border-bottom: 1px solid #e2e2e2;
}

/* .v-expansion-panel-header--active:last-of-type{

} */

#app .v-expansion-panel--active > .v-expansion-panel-header:last-of-type{
  min-height: 0;
}

/* .firstLvl .v-expansion-panel-header--active .v-expansion-panel-content__wrap > div:first-of-type {
      border-top: 1px solid #e2e2e2;
} */

#app button, #app input, #app select, #app textarea {
    /*background-color: transparent;*/
    border-style: none
}
/*!
 * ress.css • v4.0.0
 * MIT License
 * github.com/filipelinhares/ress
 */

/* # =================================================================
   # Global selectors
   # ================================================================= */

vue-app {
  box-sizing: border-box;
  -webkit-text-size-adjust: 100%; /* Prevent adjustments of font size after orientation changes in iOS */
  word-break: normal;
  -moz-tab-size: 4;
  tab-size: 4;
}

vue-app *,
vue-app::before,
vue-app::after {
  background-repeat: no-repeat; /* Set `background-repeat: no-repeat` to all elements and pseudo elements */
  box-sizing: inherit;
}

vue-app::before,
vue-app::after {
  text-decoration: inherit; /* Inherit text-decoration and vertical align to ::before and ::after pseudo elements */
  vertical-align: inherit;
}

vue-app * {
  padding: 0; /* Reset `padding` and `margin` of all elements */
  margin: 0;
}

/* # =================================================================
   # General elements
   # ================================================================= */

vue-app hr {
  overflow: visible; /* Show the overflow in Edge and IE */
  height: 0; /* Add the correct box sizing in Firefox */
  color: inherit; /* Correct border color in Firefox. */
}

vue-app details,
vue-app main {
  display: block; /* Render the `main` element consistently in IE. */
}

vue-app summary {
  display: list-item; /* Add the correct display in all browsers */
}

vue-app small {
  font-size: 80%; /* Set font-size to 80% in `small` elements */
}

vue-app [hidden] {
  display: none; /* Add the correct display in IE */
}

vue-app abbr[title] {
  border-bottom: none; /* Remove the bottom border in Chrome 57 */
  /* Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari */
  text-decoration: underline;
  text-decoration: underline dotted;
}

vue-app a {
  background-color: transparent; /* Remove the gray background on active links in IE 10 */
}

vue-app a:active,
vue-app a:hover {
  outline-width: 0; /* Remove the outline when hovering in all browsers */
}

vue-app code,
vue-app kbd,
vue-app pre,
vue-app samp {
  font-family: monospace, monospace; /* Specify the font family of code elements */
}

vue-app pre {
  font-size: 1em; /* Correct the odd `em` font sizing in all browsers */
}

vue-app b,
vue-app strong {
  font-weight: bolder; /* Add the correct font weight in Chrome, Edge, and Safari */
}

/* https://gist.github.com/unruthless/413930 */
vue-app sub,
vue-app sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

vue-app sub {
  bottom: -0.25em;
}

vue-app sup {
  top: -0.5em;
}

vue-app table {
  border-color: inherit; /* Correct border color in all Chrome, Edge, and Safari. */
  text-indent: 0; /* Remove text indentation in Chrome, Edge, and Safari */
}

/* # =================================================================
   # Forms
   # ================================================================= */

vue-app input {
  border-radius: 0;
}

/* Replace pointer cursor in disabled elements */
vue-app [disabled] {
  cursor: default;
}

vue-app [type='number']::-webkit-inner-spin-button,
vue-app [type='number']::-webkit-outer-spin-button {
  height: auto; /* Correct the cursor style of increment and decrement buttons in Chrome */
}

vue-app [type='search'] {
  -webkit-appearance: textfield; /* Correct the odd appearance in Chrome and Safari */
  outline-offset: -2px; /* Correct the outline style in Safari */
}

vue-app [type='search']::-webkit-search-decoration {
  -webkit-appearance: none; /* Remove the inner padding in Chrome and Safari on macOS */
}

vue-app textarea {
  overflow: auto; /* Internet Explorer 11+ */
  resize: vertical; /* Specify textarea resizability */
}

vue-app button,
vue-app input,
vue-app optgroup,
vue-app select,
vue-app textarea {
  font: inherit; /* Specify font inheritance of form elements */
}

vue-app optgroup {
  font-weight: bold; /* Restore the font weight unset by the previous rule */
}

vue-app button {
  overflow: visible; /* Address `overflow` set to `hidden` in IE 8/9/10/11 */
}

vue-app button,
vue-app select {
  text-transform: none; /* Firefox 40+, Internet Explorer 11- */
}

/* Apply cursor pointer to button elements */
vue-app button,
vue-app [type='button'],
vue-app [type='reset'],
vue-app [type='submit'],
vue-app [role='button'] {
  cursor: pointer;
  color: inherit;
}

/* Remove inner padding and border in Firefox 4+ */
vue-app button::-moz-focus-inner,
vue-app [type='button']::-moz-focus-inner,
vue-app [type='reset']::-moz-focus-inner,
vue-app [type='submit']::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/* Replace focus style removed in the border reset above */
vue-app button:-moz-focusring,
vue-app [type='button']::-moz-focus-inner,
vue-app [type='reset']::-moz-focus-inner,
vue-app [type='submit']::-moz-focus-inner {
  outline: 1px dotted ButtonText;
}

vue-app button,
vue-app html [type='button'], /* Prevent a WebKit bug where (2) destroys native `audio` and `video`controls in Android 4 */
vue-app [type='reset'],
vue-app [type='submit'] {
  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS */
}

/* Remove the default button styling in all browsers */
vue-app button,
vue-app input,
vue-app select,
vue-app textarea {
  background-color: transparent;
  border-style: none;
}

vue-app a:focus,
vue-app button:focus,
vue-app input:focus,
vue-app select:focus,
vue-app textarea:focus {
  outline-width: 0;
}

/* Style select like a standard input */
vue-app select {
  -moz-appearance: none; /* Firefox 36+ */
  -webkit-appearance: none; /* Chrome 41+ */
}

vue-app select::-ms-expand {
  display: none; /* Internet Explorer 11+ */
}

vue-app select::-ms-value {
  color: currentColor; /* Internet Explorer 11+ */
}

vue-app legend {
  border: 0; /* Correct `color` not being inherited in IE 8/9/10/11 */
  color: inherit; /* Correct the color inheritance from `fieldset` elements in IE */
  display: table; /* Correct the text wrapping in Edge and IE */
  max-width: 100%; /* Correct the text wrapping in Edge and IE */
  white-space: normal; /* Correct the text wrapping in Edge and IE */
  max-width: 100%; /* Correct the text wrapping in Edge 18- and IE */
}

vue-app ::-webkit-file-upload-button {
  /* Correct the inability to style clickable types in iOS and Safari */
  -webkit-appearance: button;
  color: inherit;
  font: inherit; /* Change font properties to `inherit` in Chrome and Safari */
}

/* # =================================================================
   # Specify media element style
   # ================================================================= */

vue-app img {
  border-style: none; /* Remove border when inside `a` element in IE 8/9/10 */
}

/* Add the correct vertical alignment in Chrome, Firefox, and Opera */
vue-app progress {
  vertical-align: baseline;
}

/* # =================================================================
   # Accessibility
   # ================================================================= */

/* Specify the progress cursor of updating elements */
vue-app [aria-busy='true'] {
  cursor: progress;
}

/* Specify the pointer cursor of trigger elements */
vue-app [aria-controls] {
  cursor: pointer;
}

/* Specify the unstyled cursor of disabled, not-editable, or otherwise inoperable elements */
vue-app [aria-disabled='true'] {
  cursor: default;
}
</style>
<style scoped>
/** ress.css start */

/** ress css stop */
/*Checkbox Style*/

.b-contain *, .b-contain *::before, .b-contain *::after {
	box-sizing: content-box !important;
}

.b-contain input {
	position: absolute;
	z-index: -1;
	opacity: 0;
}

.b-contain span {
	line-height: 1.54;
	font-size: 1rem;
	font-family: inherit;
}

.b-contain {
	display: table;
	position: relative;
	padding-left: 1.8rem;
	cursor: pointer;
}

.b-contain2{
  padding-left: 2.8rem;
}

.b-contain input[type="checkbox"] ~ .b-input.first {
	position: absolute;
	top: 16px;
	left: 24px;
	height: 0.8rem;
	width: 0.8rem;
	background: rgba(250, 252, 240, 1);
	transition: background 250ms;
	border: 1px solid rgba(226, 226, 226, 1);
	border-radius: 0.125rem;
}

.b-contain input[type="checkbox"] ~ .b-input {
	position: absolute;
	top: 0;
	left: 0;
	height: 0.8rem;
	width: 0.8rem;
	background: rgba(250, 252, 240, 1);
	transition: background 250ms;
	border: 1px solid rgba(226, 226, 226, 1);
	border-radius: 0.125rem;
}

.b-contain input[type="checkbox"] ~ .b-input::after {
	content: '';
	position: absolute;
	display: none;
	left: .30rem;
	top: .05rem;
	width: .20rem;
	height: .5rem;
	border: solid rgba(73, 73, 73, 1);
	border-width: 0 2px 2px 0;
	transition: background 250ms;
	transform: rotate(45deg);
}

.b-contain input[type="checkbox"] ~ .b-input::before {
    content: '';
    position: absolute;
    left: 16px;
    top: 19px;
    display:none;
    background: #000000;
    width: 8px;
    height: 2px;
    box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
    transform: rotate(0deg);
}

.b-contain input:disabled ~ .b-input::after {
	border-color: rgba(135, 149, 161, 1);
}

.b-contain input:checked ~ .b-input::after {
	display: block;
  
}

.b-contain input:checked ~ .b-input::before {
	display: none;
}

.b-contain input:indeterminate ~ .b-input::after {
  visibility: hidden;
}
.b-contain input:indeterminate ~ .b-input::before {
  display: block;
  visibility: visible;
}

.b-contain:hover input ~ .b-input,
.b-contain input:focus ~ .b-input {
	background: rgb(231, 238, 243);
}

.b-contain input:focus ~ .b-input {
	box-shadow: 0 0 0 2px rgba(250, 252, 240, 1);
}

.b-contain input:checked ~ .b-input {
	background: rgba(250, 252, 240, 1);
	border-color: rgba(226, 226, 226, 1);
}

.b-contain input[type="checkbox"]:disabled ~ .b-input {
	background: rgba(241, 245, 248, 1);
	border-color: rgba(184, 194, 204, 1);
	opacity: 0.6;
	cursor: not-allowed;
}

.b-contain input:checked:focus ~ .b-input, .b-contain:hover input:not([disabled]):checked ~ .b-input {
	background: rgba(250, 252, 240, 1);
	border-color: rgba(226, 226, 226, 1);
}

.b-contain .b-input::before {
	content: '';
	display: block;
	position: absolute;
	left: 0;
	top: 0;
	width: 3rem;
	height: 3rem;
	margin-left: -0.85rem;
	margin-top: -0.85rem;
	background: rgba(6, 143, 75, 1);
	border-radius: 2rem;
	opacity: .6;
	z-index: 99999;
	transform: scale(0);
}

.b-contain input + .b-input::before {
	animation: b-ripple 250ms ease-out;
}

.b-contain input:checked + .b-input::before {
	animation-name: b-ripple-duplicate;
}

.b-contain .b-input::before {
	visibility: hidden;
}


.b-contain input:focus + .b-input::before {
	visibility: visible;
}

.b-contain:first-child .b-input::before {
	visibility: hidden;
}

.resultButton p {
    margin-bottom: 0px;
}

.data-icon-box {
    margin-top: 16px;
}

.lastList.vsa-item__trigger:focus, .lastList .vsa-item__trigger:hover{
  color:#000000 !important;
}

.secondLvl > button{
  padding-left: 48px;
}

.thirdLvl {
      padding-left: 72px !important;
}

.firstLabel {
  padding-left: 24px !important;
  border-bottom:1px solid #e2e2e2 !important;
}

/* .border {
  border: 1px solid #e2e2e2;
  border-top: none;
} */

.heading {
  font-size: 13pt;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
}
/* .firstEbene{
  border-top: 1px solid #e2e2e2;
} */

/* .v-expansion-panel-header--active {
  border-top: 1px solid #e2e2e2;
} */

/* .secondEbene .v-expansion-panel-header--active{
  border-bottom: 1px solid #e2e2e2;
} */

/*Checkbox Style*/

.b-contain-gender *, .b-contain-gender *::before, .b-contain-gender *::after {
	box-sizing: content-box !important;
}

.b-contain-gender input {
	
	z-index: -1;
	opacity: 0;
}

.b-contain-gender span {
	line-height: 1.54;
	font-size: 1rem;
	font-family: inherit;
}

.b-contain-gender {
	position: relative;
	padding-left: 1.8rem;
	cursor: pointer;
}

.b-contain-gender input[type="checkbox"] ~ .b-input-gender.first {
	
	top: 16px;
	left: 24px;
	height: 0.8rem;
	width: 0.8rem;
	background: rgba(250, 252, 240, 1);
	transition: background 250ms;
	border: 1px solid rgba(226, 226, 226, 1);
	border-radius: 0.125rem;
}

.b-contain-gender input[type="checkbox"] ~ .b-input-gender {
	position: absolute;
	top: 0;
	left: 0;
	height: 0.8rem;
	width: 0.8rem;
	background: rgba(250, 252, 240, 1);
	transition: background 250ms;
	border: 1px solid rgba(226, 226, 226, 1);
	border-radius: 0.125rem;
}

.b-contain-gender input[type="checkbox"] ~ .b-input-gender::after {
	content: '';
	position: absolute;
	display: none;
	left: .30rem;
	top: .05rem;
	width: .20rem;
	height: .5rem;
	border: solid rgba(73, 73, 73, 1);
	border-width: 0 2px 2px 0;
	transition: background 250ms;
	transform: rotate(45deg);
}

.b-contain-gender input[type="checkbox"] ~ .b-input-gender::before {
    content: '';
    position: absolute;
    left: 16px;
    top: 19px;
    display:none;
    background: #000000;
    width: 8px;
    height: 2px;
    box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
    transform: rotate(0deg);
}

.b-contain-gender input:disabled ~ .b-input-gender::after {
	border-color: rgba(135, 149, 161, 1);
}

.b-contain-gender input:checked ~ .b-input-gender::after {
	display: block;
  
}

.b-contain-gender input:checked ~ .b-input-gender::before {
	display: none;
}

.b-contain-gender input:indeterminate ~ .b-input-gender::after {
  visibility: hidden;
}
.b-contain-gender input:indeterminate ~ .b-input-gender::before {
  display: block;
  visibility: visible;
}

.b-contain-gender:hover input ~ .b-input-gender,
.b-contain-gender input:focus ~ .b-input-gender {
	background: rgb(231, 238, 243);
}

.b-contain-gender input:focus ~ .b-input-gender {
	box-shadow: 0 0 0 2px rgba(250, 252, 240, 1);
}

.b-contain-gender input:checked ~ .b-input-gender {
	background: rgba(250, 252, 240, 1);
	border-color: rgba(226, 226, 226, 1);
}

.b-contain-gender input[type="checkbox"]:disabled ~ .b-input-gender {
	background: rgba(241, 245, 248, 1);
	border-color: rgba(184, 194, 204, 1);
	opacity: 0.6;
	cursor: not-allowed;
}

.b-contain-gender input:checked:focus ~ .b-input-gender, .b-contain-gender:hover input:not([disabled]):checked ~ .b-input-gender {
	background: rgba(250, 252, 240, 1);
	border-color: rgba(226, 226, 226, 1);
}

.b-contain-gender .b-input-gender::before {
	content: '';
	display: block;
	position: absolute;
	left: 0;
	top: 0;
	width: 3rem;
	height: 3rem;
	margin-left: -0.85rem;
	margin-top: -0.85rem;
	background: rgba(6, 143, 75, 1);
	border-radius: 2rem;
	opacity: .6;
	z-index: 99999;
	transform: scale(0);
}

.b-contain-gender input + .b-input-gender::before {
	animation: b-ripple 250ms ease-out;
}

.b-contain-gender input:checked + .b-input-gender::before {
	animation-name: b-ripple-duplicate;
}

.b-contain-gender .b-input-gender::before {
	visibility: hidden;
}

.b-contain-gender input:focus + .b-input-gender::before {
	visibility: visible;
}

.b-contain-gender:first-child .b-input-gender::before {
	visibility: hidden;
}

.resultButton p {
    margin-bottom: 0px;
}

.data-icon-box {
    margin-top: 16px;
}

.lastList.vsa-item__trigger:focus, .lastList .vsa-item__trigger:hover{
  color:#000000 !important;
}

.secondLvl > button{
  padding-left: 48px;
}

.thirdLvl {
      padding-left: 72px !important;
}

.firstLabel {
  padding-left: 24px !important;
}

/* .border {
  border: 1px solid #e2e2e2;
  border-top: none;
} */

.heading {
  font-size: 13pt;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
}
/* .firstEbene{
  border-top: 1px solid #e2e2e2;
} */

/* .v-expansion-panel-header--active {
  border-top: 1px solid #e2e2e2;
} */

/* .secondEbene .v-expansion-panel-header--active{
  border-bottom: 1px solid #e2e2e2;
} */

/* .gender-box {
  border-bottom: 1px solid #e2e2e2;
} */
.weiblich {
  margin-right: 20px;
}
div.v-expansion-panel-content {
  width: 100%;
}

.first-label {
  border-top: 1px solid red;
}

/* #app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div > div > div:nth-child(2) {
  align-items: center;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: flex;
    font-size: 0.9375rem;
    line-height: 1;
    min-height: 48px;
    outline: none;
    padding: 16px 0px 16px 48px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
} */

#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div > div > div.v-expansion-panel.secondEbene.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div > div > div.v-expansion-panel.secondLvl.v-expansion-panel--active.v-item--active > div > div > div.v-expansion-panel.thirdLvl.v-expansion-panel--active.v-item--active {
  padding-left: 0px !important;
}

#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div > div > div:nth-child(2) > label {
  padding-top: 16px;
  padding-bottom: 16px;
}

#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div > div > div:nth-child(2) > label > div, #app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div > div > div.v-expansion-panel.secondEbene.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div > div > div.v-expansion-panel.secondLvl.v-expansion-panel--active.v-item--active > div > div > div.v-expansion-panel.thirdLvl.v-expansion-panel--active.v-item--active > div > div > div:nth-child(1) > label > div {
  margin-top: 16px;
}

#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div > div > div.v-expansion-panel.secondEbene.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div > div > div.v-expansion-panel.secondLvl.v-expansion-panel--active.v-item--active > div > div > div.v-expansion-panel.thirdLvl.v-expansion-panel--active.v-item--active > div > div > div:nth-child(1) > label {
  padding-top: 16px;
  padding-bottom: 16px;
}

#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div:nth-child(2) > div > div > div.v-expansion-panel.secondEbene.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div > div > div.v-expansion-panel.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div > div > div.v-expansion-panel.thirdLvl.v-expansion-panel--active.v-item--active {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

/* #app > div > main > div > div > div.row > div.leftList.v-item-group.theme--light.v-expansion-panels > div > div.border > div > div > div.row > div.v-expansion-panel-content > div > div {
  border-bottom: 1px solid #e2e2e2;
} */

/* #babiesSelected {
  display: block;
  position: relative;
  top: 18px;
  z-index: 100;
  left: 25px;
}

/*Die Checkbox liegt oben drüber*/
.check {
  opacity: 0 !important;
    top: 18px !important;
    left: 24px !important;
    z-index: 100 !important;
}

.check2 {
  opacity: 0 !important;
    top: 18px !important;
    left: 50px !important;
    z-index: 100 !important;
}

/*Position der neuen gestylten Checkbox*/
  .b-position {
   top: 17px !important;
    left: 24px !important;
    z-index:99 !important;
}

.b-position2 {
   top: 17px !important;
    left: 50px !important;
    z-index:99 !important;
}

.accordfix {
  align-items: center;
    /* border-top-left-radius: inherit;
    border-top-right-radius: inherit; */
    display: flex;
    font-size: 0.9375rem;
    line-height: 1;
    min-height: 48px;
    outline: none;
    padding: 16px 16px 16px 48px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
}

#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div.v-expansion-panel-content > div > div.v-expansion-panel.secondEbene.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div.v-expansion-panel-content > div > div.v-expansion-panel.secondLvl.v-expansion-panel--active.v-item--active > div > div > div.v-expansion-panel.thirdLvl {
  padding-left: 0 !important;
}

#app > div > main > div > div > div.row > div.rightList.v-item-group.theme--light.v-expansion-panels > div > div > div > div > div.v-expansion-panel.v-expansion-panel--active.v-item--active > div.v-expansion-panel-content > div > div.v-expansion-panel.secondEbene.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div.v-expansion-panel-content > div > div.v-expansion-panel.secondLvl.v-expansion-panel--active.v-expansion-panel--next-active.v-item--active > div > div > div.v-expansion-panel.thirdLvl.v-expansion-panel--active.v-item--active > div > div > div:nth-child(1) {
  display: none;
}

.faqlink {
  color: #222 !important;
  text-decoration: none;
}
.rightList
.v-expansion-panel-header,
.leftList
.heading {
border-top-left-radius: 5px;
border-top-right-radius: 5px;
border-bottom-left-radius: 5px;
border-bottom-right-radius: 5px;
}

.rightList
.v-expansion-panel-header--active,
.leftList
.v-expansion-panel-header--active {
border-top-left-radius: 5px;
border-top-right-radius: 5px;
border-bottom-left-radius: 0;
border-bottom-right-radius: 0;
}

/* #app > div > main > div > div > div.row > div.leftList.v-item-group.theme--light.v-expansion-panels > div > div:nth-child(1) {
border-top-left-radius: inherit !important;
border-top-right-radius: inherit !important;
} */

.theme--light.v-expansion-panels .v-expansion-panel:not(:first-child)::after {
  display: none;
}

.data-icon:hover {
cursor: pointer;
}
.leftList
.border .v-expansion-panel button {
  border-bottom: 1px solid #e2e2e2;
}

.leftList .InnerPanels .v-expansion-panel-content__wrap > div {
 
    align-items: center;
    display: flex;
    font-size: 0.9375rem;
    line-height: 1;
    /*min-height: 48px;*/
    outline: none;
    padding: 16px 0px 16px 48px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    border-top:1px solid #e2e2e2;
}

.leftList .InnerPanels .v-expansion-panel-content__wrap > div:first-child {
  border-top: none;
}

.leftList .InnerPanels .v-expansion-panel-content__wrap > div:last-child {
  border-bottom: 1px solid #e2e2e2;
}

.border {
  border-left: 1px solid #e2e2e2;
  border-right: 1px solid #e2e2e2;
  /* border-bottom: 1px solid #e2e2e2; */
}

.rightList
.border .v-expansion-panel-header--active {
  border-bottom: 1px solid #e2e2e2;
} 

.rightList .InnerPanels .v-expansion-panel-content__wrap > div {
border-bottom: 1px solid #e2e2e2;
}

.rightList .InnerPanels .v-expansion-panel-content__wrap > div:last-child {
border-bottom: none;
}

.rightList
.border .v-expansion-panel--active {
  border-bottom: 1px solid #e2e2e2;
}

.secondLvl {
  border-bottom: 1px solid #e2e2e2;
}
.secondLvl:last-child {
  border-bottom: none;
}


.thirdLayerInput{
  position: absolute;
  left: 0.8rem;
  z-index: 99999;
  content: "";
  display: block;
  left: 0px;
  top: 0px;
  width: 1rem;
  height: 1rem;
  margin-left: 4.5rem;
  margin-top: 1.15rem;
  background: #068f4b;
  border-radius: 2rem;
  opacity: 0.2;
}

input[type="checkbox"]:checked{
    background: rgba(250, 252, 240, 1) !important;
    border-color: rgba(226, 226, 226, 1);
    opacity: 0.6;
}

.thirdLayerInput::after{
    content: '';
    position: absolute;
    display: none;
    left: 0.3rem;
    top: 0.05rem;
    width: 0.2rem;
    height: 0.5rem;
    border: solid rgba(73, 73, 73, 1);
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}


.thirdLayerCheckbox{
    left: 1rem;
}

.fourthLayerCheckbox{
  left: 2rem;
}

.greenBackground{
  background-color: #fafcf0;
  padding-left: 0px !important
}

#invisFirstChild>div>div:first-child{
  display: none;
}

</style>
